import React from "react";
import { Helmet } from "react-helmet-async";
import { ENTERPRISE_NAME } from "../../constants/configs";

const HelmetTitle = ({ title }) => (
    <Helmet>
      <title>{`${title} | ${ENTERPRISE_NAME}`}</title>
    </Helmet>
  );

export default HelmetTitle;
